import {MantineTheme, MantineThemeColors} from '@mantine/core';

import {EdgeStatus, STATUS_COLORS} from '../nodes/BenchlingNode/BenchlingNodeConstants';
import {BaseEdgeRendererData, DEFAULT_EDGE_OPTIONS, LineStyle} from './edgeOptions';

/** @package */
export function getStrokeColor(
  theme: {
    colors: MantineThemeColors;
  },
  overrideColor?: string,
  status?: EdgeStatus,
  selected?: boolean
): string {
  if (selected) {
    return theme.colors.blue[4];
  }
  if (status) {
    const statusColor = STATUS_COLORS[status];
    return theme.colors[statusColor.color][statusColor.colorIndex];
  }
  return overrideColor ?? DEFAULT_EDGE_OPTIONS.color;
}

export function getEdgePathStyle(
  theme: MantineTheme,
  data: BaseEdgeRendererData,
  selected: boolean
): React.CSSProperties {
  return {
    stroke: getStrokeColor(theme, data.color, data.status, selected),
    strokeWidth: '1.5px',
    strokeDasharray: data.lineStyle === LineStyle.DASHED ? '2 3' : undefined,
  };
}
